module.exports = __webpack_public_path__ + "img/slika28.e042fa63.jpg";